var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-phone"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.phone_number.length > 0) ? _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.client.default_phone_number.length === 9) ? _c('span', [_vm._v(_vm._s(_vm.client.default_phone_number.substring(0, 3)) + " " + _vm._s(_vm.client.default_phone_number.substring(3, 6)) + " " + _vm._s(_vm.client.default_phone_number.substring(6, 9)))]) : (_vm.client.default_phone_number.length === 13) ? _c('span', [_vm._v(_vm._s(_vm.client.default_phone_number.substring(0, 4)) + " " + _vm._s(_vm.client.default_phone_number.substring(4, 7)) + " " + _vm._s(_vm.client.default_phone_number.substring(7, 10)) + " " + _vm._s(_vm.client.default_phone_number.substring(10, 13)))]) : _c('span', [_vm._v(_vm._s(_vm.client.default_phone_number))])]) : _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-phone-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Chybí telefonní číslo")])])]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container tooltip_container tooltip_1_5_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Telefonní čísla klienta")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), (_vm.client.phone_number.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-7"
  }, [_vm._v("telefonní číslo")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("výchozí")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.client.phone_number), function(ea) {
    return [_c('tr', {
      staticClass: "row m-0 text-left",
      class: ea.default ? 'font-weight-bold' : '',
      attrs: {
        "data-testid": "client-phone-row"
      }
    }, [(_vm.editingId !== ea.id) ? _c('td', {
      staticClass: "col-sm-7"
    }, [_vm._v(_vm._s(ea.number))]) : _vm._e(), _vm._v(" "), (_vm.editingId !== ea.id) ? _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(_vm._f("boolToCS")(ea.default)))]) : _c('td', {
      staticClass: "col-sm-10"
    }, [_c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.submitFormUpdatePhoneNumber($event)
        }
      }
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedPhoneNumber.number),
        expression: "updatedPhoneNumber.number"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "telefonní číslo",
        "data-testid": "client-phone-edit-input",
        "id": "phoneNumber"
      },
      domProps: {
        "value": (_vm.updatedPhoneNumber.number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.updatedPhoneNumber.number = $event.target.value
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                                                  Výchozí: \n                                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedPhoneNumber.default),
        expression: "updatedPhoneNumber.default"
      }],
      attrs: {
        "type": "checkbox",
        "data-testid": "client-phone-edit-default"
      },
      domProps: {
        "checked": Array.isArray(_vm.updatedPhoneNumber.default) ? _vm._i(_vm.updatedPhoneNumber.default, null) > -1 : (_vm.updatedPhoneNumber.default)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.updatedPhoneNumber.default,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.updatedPhoneNumber.default = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.updatedPhoneNumber.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.updatedPhoneNumber.default = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedPhoneNumber.note),
        expression: "updatedPhoneNumber.note"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "data-testid": "client-phone-edit-note",
        "id": "phoneNumberNote",
        "placeholder": "poznámka"
      },
      domProps: {
        "value": (_vm.updatedPhoneNumber.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.updatedPhoneNumber.note = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.updatedPhoneNumberPending === false) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "data-testid": "client-phone-edit-save",
        "type": "submit"
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.updatedPhoneNumberError.number) ? _c('small', {
      staticClass: "form-text text-danger text-left",
      attrs: {
        "id": "numberError"
      }
    }, [_vm._v(_vm._s(_vm.updatedPhoneNumberError.number.message))]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "text-right col-sm-2"
    }, [(_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "data-testid": "client-phone-delete"
      },
      on: {
        "click": function($event) {
          _vm.deletePhoneNumber(ea.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-danger disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (_vm.editingId === ea.id) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": "client-phone-edit-cancel"
      },
      on: {
        "click": function($event) {
          _vm.setEditingPhoneNumber(ea)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : (_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": "client-phone-edit"
      },
      on: {
        "click": function($event) {
          _vm.setEditingPhoneNumber(ea)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), (ea.note !== null && ea.note !== '' && _vm.editingId !== ea.id) ? _c('tr', {
      staticClass: "row m-0 "
    }, [_c('td', {
      staticClass: "col-sm-12 text-left border-top-0 pt-0 font-italic"
    }, [_vm._v("Poznámka: " + _vm._s(ea.note))])]) : _vm._e()]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.editingId === false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitFormAddPhoneNumber($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPhoneNumber.number),
      expression: "newPhoneNumber.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "telefonní číslo",
      "data-testid": "client-phone-input",
      "id": "phoneNumber"
    },
    domProps: {
      "value": (_vm.newPhoneNumber.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPhoneNumber.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                      Výchozí: \n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPhoneNumber.default),
      expression: "newPhoneNumber.default"
    }],
    attrs: {
      "type": "checkbox",
      "data-testid": "client-phone-default"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPhoneNumber.default) ? _vm._i(_vm.newPhoneNumber.default, null) > -1 : (_vm.newPhoneNumber.default)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.newPhoneNumber.default,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newPhoneNumber.default = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.newPhoneNumber.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newPhoneNumber.default = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPhoneNumber.note),
      expression: "newPhoneNumber.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-phone-note",
      "id": "phoneNumberNote",
      "placeholder": "poznámka"
    },
    domProps: {
      "value": (_vm.newPhoneNumber.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPhoneNumber.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.newPhoneNumberPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-testid": "client-phone-add",
      "type": "submit"
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.newPhoneNumberError.number) ? _c('small', {
    staticClass: "form-text text-danger text-left",
    attrs: {
      "id": "numberError"
    }
  }, [_vm._v(_vm._s(_vm.newPhoneNumberError.number.message))]) : _vm._e()])])]) : _vm._e()])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a753bac","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientPhoneNumber.vue
// module id = 341
// module chunks = 0